import { useEffect, useState } from 'react'

import { Row, Col, Form } from 'react-bootstrap'
import { CheckCircleFill, XCircleFill } from 'react-bootstrap-icons'
import { SiMercadopago } from 'react-icons/si'

import { CustomButton } from '../../../components/CustomButton'
import { Modable } from '../../../components/Modable'

export function ModalEditar({ isOpen, onClose, integration }) {
  const [data, setData] = useState({
    id_conta: '',
    token: '',
    nome_conta: '',
    apelido: '',
    emp_razao: '',
    emp_cnpj: '',
    emp_ie: '',
    emp_telefone: '',
    plataforma: '',
    porc_nfe: '',
    token_refresh: '',
  })

  function handleChange(e) {
    const { name, value } = e.target

    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  function handleSubmit() {
    console.log({ data })
  }

  useEffect(() => {
    if (integration) {
      setData(integration)
    }
  }, [integration])

  return (
    <Modable
      isOpen={isOpen}
      onClose={onClose}
    >
      <div
        style={{
          padding: 15,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          flex: 1,
        }}
      >
        <h1>Editar Integração</h1>

        <main
          style={{
            width: '100%',
            flex: 1,
          }}
        >
          <Row className="mb-3">
            <Col>
              <Form.Label>ID Marketplace</Form.Label>
              <Form.Control
                name="id_conta"
                value={data.id_conta}
                onChange={handleChange}
                disabled
              />
            </Col>

            <Col>
              <Form.Label>Token</Form.Label>
              <Form.Control
                name="token"
                value={data.token}
                onChange={handleChange}
                disabled
              />
            </Col>

            <Col>
              <Form.Label>Nome Conta</Form.Label>
              <Form.Control
                name="nome_conta"
                value={data.nome_conta}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>Apelido</Form.Label>
              <Form.Control
                name="apelido"
                value={data.apelido}
                onChange={handleChange}
              />
            </Col>

            <Col>
              <Form.Label>Razão Social</Form.Label>
              <Form.Control
                name="emp_razao"
                value={data.emp_razao}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>CNPJ/CPF</Form.Label>
              <Form.Control
                name="emp_cnpj"
                value={data.emp_cnpj}
                onChange={handleChange}
              />
            </Col>

            <Col>
              <Form.Label>I.E</Form.Label>
              <Form.Control
                name="emp_ie"
                value={data.emp_ie}
                onChange={handleChange}
              />
            </Col>

            <Col>
              <Form.Label>Telefone</Form.Label>
              <Form.Control
                name="emp_telefone"
                value={data.emp_telefone}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Label>Plataforma</Form.Label>
              <Form.Control
                name="plataforma"
                value={data.plataforma}
                onChange={handleChange}
                disabled
              />
            </Col>

            <Col>
              <Form.Label>% Emissão NFE</Form.Label>
              <Form.Control
                name="porc_nfe"
                value={data.porc_nfe}
                onChange={handleChange}
              />
            </Col>

            <Col>
              <Form.Label>Token Refresh</Form.Label>
              <Form.Control
                name="token_refresh"
                value={data.token_refresh}
                onChange={handleChange}
                disabled
              />
            </Col>
          </Row>
        </main>

        <footer
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
          }}
        >
          <CustomButton
            title="Confirmar"
            color="#27ae60"
            onClick={handleSubmit}
          >
            <CheckCircleFill />
          </CustomButton>

          <CustomButton
            title="Vincular"
            titleColor="#373f8a"
            color="#f1c40f"
            onClick={handleSubmit}
          >
            <SiMercadopago size={25} />
          </CustomButton>

          <CustomButton
            title="Cancelar"
            color="#c0392b"
            onClick={onClose}
          >
            <XCircleFill />
          </CustomButton>
        </footer>
      </div>
    </Modable>
  )
}
